import { HttpClient }              from '@angular/common/http';
import {
  Inject,
  Injectable,
}                                  from '@angular/core';
import { Observable }              from 'rxjs';
import {
  Office,
  OFFICE_DATES,
}                                  from '~domain/types';
import { ENVIRONMENT }             from '../app.constants';
import { withDateDeserialization } from './interceptors';

@Injectable({
  providedIn: 'root',
})
export class OfficeApiService {

  constructor(
    @Inject(ENVIRONMENT)
    private readonly environment: Environment,
    private readonly http: HttpClient,
  ) {
  }

  fetchOffice(id: string): Observable<Office> {
    return this.http.get<Office>(
      `${this.environment.api}/offices/${id}`,
      { context: withDateDeserialization(OFFICE_DATES) },
    );
  }
}
